import { Form, FormItemProps, Switch } from 'antd'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import type { SwitchProps } from 'antd/lib'

type BooleanSwitchProps = {
  title: string
  name: string
  message?: string
  initialValue?: FormItemProps['initialValue']
  required?: boolean
} & SwitchProps

export function BooleanSwitch({ title, name, message, initialValue, required = false, ...others }: BooleanSwitchProps) {
  return (
    <Horizontal gap={8} verticalCenter justifyContent='space-between'>
      <Texto>{title}</Texto>
      <Form.Item
        name={name}
        valuePropName='checked'
        noStyle
        initialValue={initialValue}
        rules={[{ required, message }]}
      >
        <Switch {...others} />
      </Form.Item>
    </Horizontal>
  )
}
